import Header from "../navigation/header";
import {
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  Switch,
  Modal,
  Dimensions,
} from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Text, View } from "../../../components/Themed";
import { jsonToCSV } from "react-native-csv";

import { RootStackScreenProps } from "../../../types";
import React, { useEffect, useState } from "react";
import Icon from "react-native-vector-icons/AntDesign";
import { useFocusEffect } from "@react-navigation/native";
import { postData } from "../../../networking/api";
import DataTable from "react-data-table-component";
import { ActivityIndicator } from "react-native";

import { TextInput } from "react-native-paper";
import { Provider as PaperProvider } from "react-native-paper";
import IconEdit from "react-native-vector-icons/FontAwesome";
import IconCross from "react-native-vector-icons/Entypo";
import IconEye from "react-native-vector-icons/Entypo";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function FarmerProfile({ navigation }) {
  const [text, setText] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  var [counter, setCounter] = useState(1);

  const [projectId, setProjectId] = useState("");

  const [isLoading, setIsLoading] = useState(true);
  const [FarmerDataLength, setFarmerDataLength] = useState(0);
  const [FarmerNameData, setFarmerNameData] = useState([]);

  const [searchData, setSearch] = useState("");
  const [filterData, setFilteredDataSource] = useState([]);
  const [isFarmerNameDataValid, setFarmerNameDataValid] = useState(false);
  const [isFarmerNameDataEntered, setFarmerNameDataEntered] = useState(false);
  const [sort, setsort] = useState(0);

  const [editpopup, setEditPopup] = useState(false);
  const [popid, setpopid] = useState("");
  const [popindex, setpopindex] = useState("");
  const customStyles = {
    rows: {
      style: {
        minHeight: "30px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        backgroundColor: "#319ef0a3",
        minHeight: "40px",
        fontSize: 16,
        fontWeight: "600",
      },
    },
    headCells: {
      style: {
        justifyContent: "center",
        minHeight: "20px",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
        justifyContent: "center",

        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          fontSize: 16,
          fontWeight: "400",
        },
      },
    },
  };
  const caseInsensitiveSort = (rowA, rowB) => {
    const a = rowA.farmer_name.toLowerCase();
    const b = rowB.farmer_name.toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };
  const columns = [
    {
      name: "Sr.No",
      selector: (row) => row.index,

      width: "100px",
    },
    {
      name: " Name",
      selector: "farmer_name",
      sortable: true,
      sortFunction: caseInsensitiveSort,
      style: { textTransform: "Capitalize" },
    },
    {
      name: "Email",
      selector: "email_id",
      sortable: true,
    },
    {
      name: "Mobile",
      selector: "mobile_number",
      sortable: true,
    },
    {
      name: "No. of Field",
      selector: (row) => (row.field_id_count == null ? "" : row.field_id_count),
      sortable: true,
    },
    {
      name: "Area",
      selector: (row) => {
        const value = parseFloat(row.cultivated_area);
        if (isNaN(value)) return "";

        return Number.isInteger(value) ? `${value} h` : `${value.toFixed(2)} h`;
      },
      sortable: true,
    },
    {
      name: "Water Demand",
      selector: (row) =>
        row.water_demand == null ? "" : row.water_demand + " m³",
      sortable: true,
    },
    {
      name: "Action",
      width: "100px",

      cell: (item) => (
        <TouchableOpacity
          style={{ marginRight: 10 }}
          onPress={() => {
            navigation.navigate("EditFarmerProfile", { farmerId: item.id });
          }}
        >
          <IconEdit
            name="pencil"
            size={13}
            color="#fff"
            style={{
              padding: 6,
              backgroundColor: "#08588E",
              borderRadius: 12,
            }}
          />
        </TouchableOpacity>
      ),
    },
    {
      name: "Status",
      width: "100px",

      cell: (item, index) => (
        <Switch
          trackColor={{ false: "#767577", true: "#1DA1F2" }}
          thumbColor={item.active == 1 ? "#fff" : "#f4f3f4"}
          activeThumbColor="#fff"
          onValueChange={() => {
            setEditPopup(true);
            setpopid(item.id);
            setpopindex(index);
          }}
          value={item.active == 1 ? true : false}
        />
      ),
    },
  ];
  const toggleSwitch = () => {
    var tempIndex = FarmerNameData.findIndex((item) => item.id === popid);

    if (FarmerNameData[tempIndex].active == 1) {
      FarmerNameData[tempIndex].active = 0;
      activeFarmer(popid, 0);
    } else {
      FarmerNameData[tempIndex].active = 1;
      activeFarmer(popid, 1);
    }
    setFarmerNameData(FarmerNameData);
  };
  const optionsPerPage = [10, 25, 50, 100];

  const [page, setPage] = React.useState(0);
  const [itemsPerPage, setItemsPerPage] = React.useState(optionsPerPage[0]);
  const from = page * itemsPerPage;
  const to = Math.min((page + 1) * itemsPerPage, FarmerDataLength);
  React.useEffect(() => {
    setPage(0);
    setpopindex("");
    setEditPopup(false);
    setpopid("");
  }, [itemsPerPage]);

  useFocusEffect(
    React.useCallback(() => {
      getAdminData();
    }, []),
  );

  const getAdminData = async () => {
    let jsonValue = await AsyncStorage.getItem("userData");
    let projValue = await AsyncStorage.getItem("projectData");

    if (projValue != null) {
      setProjectId(projValue);
      getAllFarmerData([], projValue);
    } else if (jsonValue != null) {
      var userDetailsresponse = JSON.parse(jsonValue);

      setProjectId(userDetailsresponse.project_selected);
      getAllFarmerData([], userDetailsresponse.project_selected);
    }
  };

  const searchFilterFunction = (text) => {
    if (text) {
      const newData = FarmerNameData.filter(function (item) {
        const textData = text.toUpperCase();
        const itemData = [

          item.farmer_name,
          item.email_id,
          item.mobile_number,
          item.field_id_count,
          item.cultivated_area,
          item.water_demand,
        ]
          .filter((value) => value !== null && value !== undefined)
          .join(" ")
          .toUpperCase();
        return itemData.indexOf(textData) > -1;
      });
      setFilteredDataSource(newData);
      setSearch(text);
      setPage(0);
    } else {
      setFilteredDataSource(FarmerNameData);
      setSearch(text);
      setPage(0);
    }
  };
  const activeFarmer = async (fId, isActive) => {
    setIsLoading(true);
    try {
      var farmerData = JSON.stringify({
        id: fId,
        module: "farmer_master",
        data: {
          active: isActive,
        },
      });
      const activeFarmerResponse = await postData(
        farmerData,
        "masters/masterCreateUpdate",
      );

      setIsLoading(false);

      var code = activeFarmerResponse.code;
      if (code == 1) {
        setIsVisible(false);
        getAllFarmerData([], projectId);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const exportCsvFarmerData = async () => {
    setIsLoading(true);
    try {
      var getFarmerData = JSON.stringify({
        module: "farmer_master",
      });
      const FarmerNameResponse = await postData(
        getFarmerData,
        "masters/exportFile",
      );
      setIsLoading(false);
      var code = FarmerNameResponse.code;
      if (code == 1) {
        setFarmerNameData(FarmerNameResponse.data);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error", error);
    }
  };
  const getAllFarmerData = async (sortdata: never[], pid) => {
    setIsLoading(true);
    if (sortdata.length > 0) {
      setFarmerDataLength(sortdata.length);
      setFarmerNameData(sortdata);
      setFilteredDataSource(sortdata);
    } else {
      try {
        var getFarmerData = JSON.stringify({
          project_id: pid,
        });
        const FarmerNameResponse = await postData(
          getFarmerData,
          "masters/getFarmerProfilelist",
        );
        setIsLoading(false);
        var code = FarmerNameResponse.code;
        if (code == 1) {
          setFarmerDataLength(FarmerNameResponse.data.length);
          setFarmerNameData(FarmerNameResponse.data);
          setFilteredDataSource(FarmerNameResponse.data);
          const results = jsonToCSV(FarmerNameResponse.data);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error", error);
      }
    }
  };
  const sortFun = () => {
    const sortData = filterData.sort((item, b) =>
      sort == 1
        ? item.farmer_name.localeCompare(b.farmer_name)
        : b.farmer_name.localeCompare(item.farmer_name),
    );
    getAllFarmerData(sortData, projectId);
    setFilteredDataSource(sortData);
  };
  const screenwidth = Dimensions.get("window").width;
  const isMobile = screenwidth < 768;

  return (
    <View style={styles.container}>
      <View
        style={
          isMobile
            ? { width: "100%", marginTop: 200 }
            : { flexDirection: "row", width: "100%", marginTop: "10%" }
        }
      >
        <View style={{ flex: 1, margin: 10 }}>
          <Text style={styles.lableText}>Profile {">"} Farmer Profile</Text>
        </View>
        <Modal
          visible={editpopup}
          animationType={"slide"}
          transparent={true}
          onRequestClose={() => {
            setEditPopup(false);
          }}
        >
          <View
            style={
              isMobile
                ? {
                    backgroundColor: "white",
                    borderColor: "#eee",
                    borderRadius: 5,
                    alignSelf: "center",
                    borderWidth: 1,
                    height: "25%",
                    margin: "auto",
                    padding: 10,
                    shadowOffset: {
                      width: 0,
                      height: 2,
                    },
                    shadowOpacity: 0.25,
                    shadowRadius: 4,
                    elevation: 5,
                    width: "60%",
                  }
                : [styles.contanerSwitch]
            }
          >
            <TouchableOpacity
              style={{ alignSelf: "flex-end" }}
              onPress={() => setEditPopup(false)}
            >
              <IconCross
                name="circle-with-cross"
                size={20}
                color="#000"
                style={{ bottom: 5, top: 0 }}
              />
            </TouchableOpacity>

            <Text style={[styles.tableHeader, { marginBottom: 20 }]}>
              Do You Want Update Status
            </Text>
            <View
              style={{
                flexDirection: "row",
                paddingRight: 10,
                justifyContent: "space-between",
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  (setEditPopup(false), toggleSwitch());
                }}
                style={styles.saveBtn}
              >
                <Text style={{ color: "white" }}>Yes</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  setEditPopup(false);
                }}
                style={styles.saveBtn}
              >
                <Text style={{ color: "white" }}>No</Text>
              </TouchableOpacity>
            </View>
          </View>
        </Modal>
        <View
          style={
            isMobile
              ? {
                  alignItems: "center",
                  marginTop: 20,
                  marginLeft: "-35%",
                  width: "170%",
                  flex: 2,
                }
              : { alignItems: "center", flex: 2 }
          }
        >
          <TextInput
            style={
              isMobile
                ? {
                    height: 35,
                    borderWidth: 2,
                    paddingLeft: 10,
                    borderColor: "#319ef0",
                    backgroundColor: "#FFFFFF",
                    width: "50%",
                    borderRadius: 5,
                    color: "#000",
                    fontWeight: "400",
                  }
                : styles.textInputStyle
            }
            onChangeText={(text) => searchFilterFunction(text)}
            value={searchData}
            underlineColorAndroid="transparent"
            underlineColor={"white"}
            placeholder="Search farmers"
            theme={{
              colors: {
                text: "black",
                primary: "white",
                background: "transparent",
              },
            }}
            left={
              <TextInput.Icon
                name={() => <IconEdit name="search" size={20} color="#000" />}
              />
            }
          />
        </View>
        <View style={{ flex: 1, alignItems: "flex-end" }}>
          <TouchableOpacity
            style={
              isMobile
                ? {
                    alignItems: "center",
                    backgroundColor: "#006EB9",
                    padding: 10,
                    borderWidth: 1,
                    borderColor: "#006EB9",
                    width: "35%",
                  }
                : styles.addDevice
            }
            onPress={() => {
              navigation.navigate("CreateFarmerProfile");
            }}
          >
            <Text style={styles.btnText}>
              <Icon name="plus" size={15} color="#fff" /> Create
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      <View style={{ flexDirection: "row", width: "100%" }}>
        <View style={{ flex: 1 }}></View>
      </View>

      <View
        style={
          isMobile
            ? [styles.card, { flexGrow: 1, marginTop: 50, paddingBottom: 10 }]
            : [styles.card, { flexGrow: 1 }]
        }
      >
        <View
          style={[
            styles.shadowProp,
            {
              backgroundColor: "white",
            },
          ]}
        >
          <View
            style={{
              width: "100%",
              backgroundColor: "#F6F9F9",
            }}
          >
            <View
              style={
                isMobile
                  ? {
                      borderWidth: 1,
                      borderColor: "#e3e0e0",
                      width: "100%",
                      alignSelf: "center",
                    }
                  : {
                      borderWidth: 1,
                      borderColor: "#e3e0e0",
                    }
              }
            >
              <View>
                {isLoading ? (
                  <ActivityIndicator
                    color="#1DA1F2"
                    visible={isLoading}
                    textContent={"Loading..."}
                    size={80}
                  />
                ) : (
                  <DataTable
                    columns={columns}
                    data={filterData}
                    customStyles={customStyles}
                    pagination
                  />
                )}
              </View>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  input: {
    borderColor: "gray",
    width: "60%",
    borderWidth: 1,
    borderRadius: 10,

    padding: 10,
  },
  tableHead: {
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "400",
    color: "#000",
  },
  addDevice: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "50%",
  },
  contanerSwitch: {
    backgroundColor: "white",
    borderColor: "#eee",
    borderRadius: 5,
    alignSelf: "center",
    borderWidth: 1,
    height: "25%",
    margin: "auto",
    padding: 10,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    width: "30%",
  },
  saveBtn: {
    alignItems: "center",
    backgroundColor: "#006EB9",
    padding: 10,
    borderWidth: 1,
    borderColor: "#006EB9",
    width: "50%",
    marginRight: 10,
  },
  tableHeader: {
    color: "#000",
    fontSize: 14,
    /* FontFamily: 'Muli' ,*/
    fontWeight: "700",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  btnText: {
    color: "#fff",
    fontWeight: "600",
  },
  card: {
    width: "100%",
    flex: 1,
    marginVertical: 10,
  },
  shadowProp: {
    shadowColor: "#171717",
    shadowOffset: { width: -2, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 25,
  },
  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  linkText: {
    fontSize: 14,
    color: "#2e78b7",
  },
  textInputStyle: {
    height: 35,
    borderWidth: 2,
    paddingLeft: 10,
    borderColor: "#319ef0",
    backgroundColor: "#FFFFFF",
    width: "40%",
    borderRadius: 5,
    color: "#000",
    fontWeight: "400",
  },
  lableText: {
    color: "#484848",
    fontWeight: "700",
    marginTop: 18,
  },
});
